<template>
    <div>
        <!-- Begin Page Content -->
        <div class="Medication-section">
            <div class="row">
                <div class="col-md-7 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3 text-center d-flex justify-content-center align-items-center">
                            <form class="checkout">
                                <div class="input-group mb-4">
                                    <label>Name</label>
                                    <input type="text" name="text" placeholder="Punit  Sharma" />
                                </div>
                                <div class="input-group mb-4">
                                    <label>Email Address</label>
                                    <input type="text" name="text" placeholder="psharma.stackflow.org" />
                                </div>
                                <div class="input-group mb-4">
                                    <label>Country</label>
                                    <select>
                                        <option>India</option>
                                        <option>India</option>
                                        <option>India</option>
                                        <option>India</option>
                                        <option>India</option>
                                        <option>India</option>
                                    </select>
                                </div>
                                <div class="input-group mb-4">
                                    <label>Address</label>
                                    <input type="text" name="text" placeholder="123 India " />
                                </div>
                                <div class="row no-gutters mb-4 w-100">
                                    <div class="col-md-6 pr-3">
                                        <div class="input-group">
                                            <label>State</label>
                                            <input type="text" name="text" placeholder="Chandigarh" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 pl-3">
                                        <div class="input-group">
                                            <label>Zip Code</label>
                                            <input type="text" name="text" placeholder="160047" />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 mb-4 text-left valid-prescription">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-4 text-left">
                            <div class="text-left bg-body border-radius-8 p-4 mb-4 Tablet-section">
                                <div class="d-flex justify-content-between align-items-center mb-4">
                                    <h3><i class="icon icon-shopping-cart"></i> Cart Summary</h3>
                                    <a href="#" class="edit">Edit</a>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="text-left pr-4">
                                        <h5>Shelcal HD 12 Tablet (15 Tab)</h5>
                                        <p>Decode your gene-health- nutrition relationship</p>
                                    </div>
                                    <div class="text-left">
                                        <h3 class="price">$45.95</h3>
                                    </div>
                                </div>
                                <div class="Sub-Total d-flex justify-content-end border-top">
                                    <h4>Sub Total: <span>$45.95</span></h4>
                                </div>
                            </div>
                            <router-link class="btn btn-blue Place-Order w-100" to="/prescription-order-confirm">Place Order</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Checkout",
        data() {
            return {};
        },
        created(){
           this.pageName('Checkout')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/checkup/checkout.vue